import { useEffect } from 'react';
import { isMobile } from '@/utils';
import ExceptionPage from '@/components/ExceptionPage';

const AccessDenied = () => {

  useEffect(() => {
    const errorObj: any = new Error('BlankScreen');
    errorObj.name = 'not access denied';
    window.Sentry?.captureException(errorObj);
  }, []);

  return (
    <ExceptionPage
      title="您没有权限访问该页面"
      isMobile={isMobile}
      onReturn={() => {
        window.location.href = '/';
      }}
      buttonText="返回"
    />
  );
};

export default AccessDenied;
